module.exports = __webpack_public_path__ + "img/prew.152a8c82.svg";